var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrap"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('resize-observer',{on:{"notify":_vm.handleResize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }